import { render, staticRenderFns } from "./Saying.vue?vue&type=template&id=80bbee64&scoped=true&"
import script from "./Saying.vue?vue&type=script&lang=js&"
export * from "./Saying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bbee64",
  null
  
)

export default component.exports